import { zIndex } from 'helpers/constants';
import styled from 'styled-components/macro';

export const Footer = styled.footer`
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  position: fixed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 68px;
  min-height: 68px;
  background-color: #ecf0f1;
  padding: 0 20px;
  z-index: ${zIndex.footer};
`;

export const RightGroupStyled = styled.div`
  display: flex;
  & > * {
    margin-left: 8px;
  }
`;
